// Card-brand acceptance marks shown next to the Stripe inputs so users know
// which networks are accepted before they start typing.
//
// The three SVGs in ./assets are the official vector marks (Visa wordmark
// 2021, Mastercard symbol without wordmark as the brand guidelines allow at
// small sizes, American Express blue box). Vite inlines them as data URIs, so
// there is no extra request and no broken-image risk in the host page; the
// <img> elements are inline-styled like everything else in the modal, so a
// host theme cannot resize or hide them.
import amexUrl from './assets/amex.svg';
import mastercardUrl from './assets/mastercard.svg';
import visaUrl from './assets/visa.svg';

const frameStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 40,
  height: 26,
  boxSizing: 'border-box',
  border: '1px solid #d2d2d9',
  borderRadius: 3,
  background: '#ffffff',
  flexShrink: 0,
  overflow: 'hidden',
};

function Mark({ src, alt, width }: { src: string; alt: string; width: number }) {
  return (
    <span style={frameStyle} role="img" aria-label={alt}>
      <img src={src} alt="" style={{ width, height: 'auto', display: 'block', border: 0, margin: 0, padding: 0 }} />
    </span>
  );
}

export function CardBrandLogos() {
  return (
    <div
      style={{
        display: 'flex',
        gap: 8,
        alignItems: 'center',
      }}
      aria-label="Akzeptierte Kreditkarten"
    >
      <Mark src={visaUrl} alt="Visa" width={28} />
      <Mark src={mastercardUrl} alt="Mastercard" width={24} />
      <Mark src={amexUrl} alt="American Express" width={24} />
    </div>
  );
}
